import React from "react";
import { Button } from "antd";
import moment from "moment";
import Table_Icon from "../../../../assets/images/table.svg";
import Packet_Icon from "../../../../assets/images/packet.svg";
import Bike_Icon from "../../../../assets/images/bike.svg";

const Card2 = (props) => {
  const cardClass = {
    LOW: "low",
    MEDIUM: "medium",
    HIGH: "high",
  };
  const orderType = {
    POS: Table_Icon,
    ONLINE_DELIVERY: Bike_Icon,
    ONLINE_TAKEOUT: Packet_Icon,
    ONLINE_CATERING: Packet_Icon,
  };
  const { cardData, onAcknoledgeOrder } = props;

  const firstOrder = cardData[cardData.length - 1] || 'HIGH';

  if (!cardData.length) {
    return null;
  }

  return (
    <div className="expo_card">
      <div className={"head_title " + cardClass[firstOrder.kitchen_priority]}>
        <div>
          <img src={orderType[firstOrder.cart.order_type]} alt="" />
        </div>
        <div>{moment(firstOrder.updated_at).fromNow()}</div>
      </div>
      <div className="card_content">
      {cardData.map((item, idx) => (
        <div className="content_item" key={item.menu_item.id}>
          <div className="content_rowtext">
            <div>{item.quantity}</div>
            <div className="cross">x</div>
            <div className="item_name">
              <div className="name_row">
                <div>{item.menu_item.name}</div>
              </div>
              <p className="item_info">Note: --</p>
            </div>
          </div>
        </div>
      ))}
        <Button
          type="primary"
          className="bump_btn"
          onClick={() => {
            onAcknoledgeOrder(cardData, "is_kitchen_acknowledged");
          }}
        >
          Acknowledge
        </Button>
      </div>
    </div>
  );
};
export default Card2;
